import { put, call } from "redux-saga/effects";
import { channelConstants } from "../actions/constants/channelConstants";
import { ChannelService } from "../services/api/channelService";
import { exceptionHandler } from "../pages/common/functions";

function* channelSave(request: any) {
	try {
		const result = yield call(ChannelService.channelSave, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: channelConstants.ChannelSaveSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: channelConstants.ChannelSaveFailure, payload: res.data });
		}
	} catch (e) {
		yield put({ type: channelConstants.ChannelSaveFailure, payload: e});
	}
}

function* channelGetDetail(request: any) {
	try {
		const result = yield call(ChannelService.channelGetDetail, request.input.id, request.input.code);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: channelConstants.ChannelDetailSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: channelConstants.ChannelDetailFailure, payload: res.data});
		}
	} catch (e) {
		yield put({ type: channelConstants.ChannelDetailFailure, payload: e });
	}
}

function* channelGetByfilter(request: any) {
	try {
		const result = yield call(ChannelService.channelGetByfilter, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: channelConstants.ChannelGetByfilterSuccess,
				payload: res.data
			});
		} else {
			yield put({ type: channelConstants.ChannelGetByfilterFailure, payload: res.data });
		}	
	} catch (e) {
		yield put({type: channelConstants.ChannelGetByfilterFailure,payload: e});
	}
}

function* channelGetAll(request: any) {
	try {
		const result = yield call(ChannelService.channelGetAll, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: channelConstants.ChannelGetAllSuccess,
				payload: res.data
			});
		} else {
			yield put({ type: channelConstants.ChannelGetAllFailure, payload: res.data });
		}		
	} catch (e) {
		yield put({ type: channelConstants.ChannelGetAllFailure, payload:e});
	}
}

function* channelDelete(request: any) {
	try {
		const result = yield call(ChannelService.channelDelete, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: channelConstants.ChannelDeleteSuccess,
				payload: res.data
			});
		}
		else {
			yield put({ type: channelConstants.ChannelDeleteFailure, payload: res.data });
		}
	} catch (error) {
		yield put({ type: channelConstants.ChannelDeleteFailure, payload: error});
	}
}

function* channelGetFavourite(request: any) {
	try {
		const result = yield call(ChannelService.channelGetFavourite, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: channelConstants.ChannelFaviruteSuccess,
				payload: res.data.userRecentChannels
			});
		}
		else {
			yield put({
				type: channelConstants.ChannelFaviruteFailure,
				payload: res.data
			});
		}
	} catch (e) {
		yield put({
			type: channelConstants.ChannelFaviruteFailure,
			payload: e
		});
	}

}

function* channelGetNonFavourite(request: any) {
	try {
		const result = yield call(ChannelService.channelGetNonFavourite, request.input);
		var res = exceptionHandler(result);
		if (res.status) {
			yield put({
				type: channelConstants.ChannelnonFaviruteSuccess,
				payload: res.data.userRecentChannels
			});
		}
		else {
			yield put({
				type: channelConstants.ChannelnonFaviruteFailure,
				payload: res.data
			});
		}
	} catch (e) {
		yield put({
			type: channelConstants.ChannelnonFaviruteFailure,
			payload: e
		});
	}

}

export const channelSaga = {
	channelSave,
	channelGetDetail,
	channelGetAll,
	channelGetByfilter,
	channelDelete,
	channelGetFavourite,
	channelGetNonFavourite
}
